import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type {
  AxiosInstance,
  AxiosResponse,
} from "axios";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_GRUPO_ESCALAS_BACKEND_API_URL ||
  "http://localhost:4004/api";

const negociacionesGrupoEscalaApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(negociacionesGrupoEscalaApi);

negociacionesGrupoEscalaApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesGrupoEscalaApi };
